// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Глобальные стили для Telegram WebApp */
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  /* Устанавливаем безопасные отступы для Telegram */
  padding: var(--tg-safe-area-inset-top, 0) 
           var(--tg-safe-area-inset-right, 0) 
           var(--tg-safe-area-inset-bottom, 0) 
           var(--tg-safe-area-inset-left, 0);
  /* Применяем фон который меняется с темой */
  background-color: var(--app-bg-color, #ffffff);
  color: var(--app-text-color, #000000);
}

/* Глобальные переменные для темы */
:root {
  --tg-theme-bg-color: #ffffff;
  --tg-theme-text-color: #1d1d1d;
  --tg-theme-hint-color: #999999;
  --tg-theme-link-color: #2481cc;
  --tg-theme-button-color: #2481cc;
  --tg-theme-button-text-color: #ffffff;
  --tg-theme-secondary-bg-color: #f1f1f1;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Убираем стандартные отступы и устанавливаем box-sizing */
* {
  box-sizing: border-box;
}

html {
  height: 100%;
  /* Предотвращаем зум при двойном тапе */
  touch-action: manipulation;
}

#root {
  min-height: 100vh;
  width: 100%;
}

/* CSS для анимации смены темы через View Transition API */
::view-transition-old(root),
::view-transition-new(root) {
  animation: none;
  mix-blend-mode: normal;
}

/* Дополнительные стили для плавной смены темы */
:root.theme-dark {
  --app-bg-color: #1d1d1d;
  --app-text-color: #ffffff;
}

:root.theme-light {
  --app-bg-color: #f5f5f5;
  --app-text-color: #1d1d1d;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,SAAS;EACT,UAAU;EACV;;uCAEqC;EACrC,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,kDAAkD;EAClD;;;4CAG0C;EAC1C,2CAA2C;EAC3C,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,gCAAgC;EAChC,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE;aACW;AACb;;AAEA,2DAA2D;AAC3D;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,0DAA0D;AAC1D;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA,gDAAgD;AAChD;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B","sourcesContent":["/* Глобальные стили для Telegram WebApp */\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB',\n    'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif, 'Apple Color Emoji',\n    'Segoe UI Emoji', 'Segoe UI Symbol';\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n  /* Устанавливаем безопасные отступы для Telegram */\n  padding: var(--tg-safe-area-inset-top, 0) \n           var(--tg-safe-area-inset-right, 0) \n           var(--tg-safe-area-inset-bottom, 0) \n           var(--tg-safe-area-inset-left, 0);\n  /* Применяем фон который меняется с темой */\n  background-color: var(--app-bg-color, #ffffff);\n  color: var(--app-text-color, #000000);\n}\n\n/* Глобальные переменные для темы */\n:root {\n  --tg-theme-bg-color: #ffffff;\n  --tg-theme-text-color: #1d1d1d;\n  --tg-theme-hint-color: #999999;\n  --tg-theme-link-color: #2481cc;\n  --tg-theme-button-color: #2481cc;\n  --tg-theme-button-text-color: #ffffff;\n  --tg-theme-secondary-bg-color: #f1f1f1;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Убираем стандартные отступы и устанавливаем box-sizing */\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  height: 100%;\n  /* Предотвращаем зум при двойном тапе */\n  touch-action: manipulation;\n}\n\n#root {\n  min-height: 100vh;\n  width: 100%;\n}\n\n/* CSS для анимации смены темы через View Transition API */\n::view-transition-old(root),\n::view-transition-new(root) {\n  animation: none;\n  mix-blend-mode: normal;\n}\n\n/* Дополнительные стили для плавной смены темы */\n:root.theme-dark {\n  --app-bg-color: #1d1d1d;\n  --app-text-color: #ffffff;\n}\n\n:root.theme-light {\n  --app-bg-color: #f5f5f5;\n  --app-text-color: #1d1d1d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
